
const digest = 'fb76bb31aee6c72a9ef7c084024bebaed99b6933f0e9db4edefbd4bd1dfa3435';
const classes = {"wrapper":"_wrapper_136xi_1","checkbox":"_checkbox_136xi_10","description":"_description_136xi_20","active":"_active_136xi_25","title":"_title_136xi_30","disabled":"_disabled_136xi_36"};
const css = `._wrapper_136xi_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  height: fit-content;
  font-family: Rubik, "sans-serif";
}

._checkbox_136xi_10 {
  min-width: 25px;
  min-height: 25px;
  max-width: 25px;
  max-height: 25px;
  background: url("/dist/icons/react/fakebox.svg") no-repeat center;
  background-size: contain;
  cursor: pointer;
}

._description_136xi_20 {
  margin-left: 7.5px;
  font-size: 12px;
}

._active_136xi_25 {
  background: url("/dist/icons/react/fakebox-checked.svg") no-repeat center;
  background-size: contain;
}

._title_136xi_30 {
  font-size: 14px;
  font-weight: 500;
  margin-left: 7.5px;
}

._disabled_136xi_36 {
  cursor: not-allowed;
}
._disabled_136xi_36 ._checkbox_136xi_10 {
  opacity: 0.8;
  cursor: not-allowed;
}
._disabled_136xi_36 ._title_136xi_30 {
  color: #939393;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  